import colors from '@/design/colors';
import shadows from '@/design/shadows';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    border: none;
    box-sizing: border-box;
  }

  body {
    -webkit-font-smoothing: antialiased;
    background-color: ${colors.gray50};
  }

  body, input, button, textarea {
    font: 16px 'Source Sans Pro', sans-serif;
    color: ${colors.black};
  }

  button {
    cursor: pointer;
    background: none;
  }

  ul {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  /**
   * Prevent background scrolling when overlay appears
   */
  html.noscroll {
    overflow: hidden;
  }

  .tippy-tooltip {
    font-size: 12px;
    background-color: #2f3139;
    border-radius: 4px;
  }

  .tippy-box[data-theme~='card'] {
    display: flex;
    flex-direction: row;
    padding: 10px;
    align-items: flex-start;
    gap: 4px;
  
    border-radius: 8px;
    border: 1px solid ${colors.gray100};
    background: ${colors.white};
  
    /* Small Shadow */
    box-shadow: ${shadows.smallShadow};
  }
`;
